import { render, staticRenderFns } from "./FormattedInput.vue?vue&type=template&id=0c894c97&scoped=true&"
import script from "./FormattedInput.vue?vue&type=script&lang=ts&"
export * from "./FormattedInput.vue?vue&type=script&lang=ts&"
import style0 from "./FormattedInput.vue?vue&type=style&index=0&id=0c894c97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c894c97",
  null
  
)

export default component.exports